module.exports = __webpack_public_path__ + "static/img/Diamond2.b595d0e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/game-ranks/apex/Diamond2.svg
// module id = N2Rd
// module chunks = 35